const API_KEY = 'AIzaSyA0T6aBdVaTiLwzfnM4dxSah2-xoTU6hhs';
// AIzaSyAmVyYQ_p7S_GbRMdJjLJUD7UX4wNHlYhQ
// AIzaSyAHpOu1_tdtzXkYeG01xnPA7RfBM5nEF8c

export default {
  googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&v=3.exp&libraries=geometry,drawing,places`
};
